import React from "react";
import { Col, Form, Row, Typography } from "antd";
import {
  ApartmentOutlined,
  ArrowRightOutlined,
  CalendarOutlined,
  MailOutlined,
} from "@ant-design/icons";
import { useQuery } from "react-query";
import { get, find } from "lodash";
import { AxiosAreasAPI } from "../Api";

const ParentAreaModalInfo = ({ form, area }) => {
  const { Title } = Typography;
  const parentId = Form.useWatch("parent_id", form);
  const startDate = Form.useWatch("start_date", form);
  const endDate = Form.useWatch("end_date", form);
  const parentLowerTimespan = get(
    find(
      area._links.parents,
      (p) => p.parent.code === get(area, "parent_info.code"),
    ),
    "timespan.lower",
  );

  const { data: newParent } = useQuery(
    ["newParentAreaEditionInfo", parentId],
    () => AxiosAreasAPI.getById(parentId, {}),
    {
      enabled: !!parentId,
    },
  );

  return (
    <Row>
      <Col offset={3} span={8}>
        <Title level={5}>Área pai atual</Title>
        <AreaInfoCell
          icon={<ApartmentOutlined />}
          info={get(area, "parent_info.name", "-")}
          label={"Nome"}
        />
        <AreaInfoCell
          icon={<MailOutlined />}
          info={get(area, "parent_info.code", "-")}
          label={"Código"}
        />
        <AreaInfoCell
          icon={<CalendarOutlined />}
          info={
            parentLowerTimespan ? parentLowerTimespan.format("DD/MM/YYYY") : "-"
          }
          label={"Data de início"}
        />
        <AreaInfoCell
          icon={<CalendarOutlined />}
          info={endDate?.format("DD/MM/YYYY") || "-"}
          label={"Data de fim"}
        />
      </Col>
      <Row justify={"center"} align={"middle"}>
        <Col>
          <ArrowRightOutlined style={{ fontSize: "24px" }} />
        </Col>
      </Row>
      <Col offset={3} span={8}>
        <Title level={5}>Nova área pai</Title>
        <AreaInfoCell
          icon={<ApartmentOutlined />}
          info={get(newParent, "name", "-")}
          label={"Nome"}
        />
        <AreaInfoCell
          icon={<MailOutlined />}
          info={get(newParent, "code", "-")}
          label={"Código"}
        />
        <AreaInfoCell
          icon={<CalendarOutlined />}
          info={startDate?.format("DD/MM/YYYY") || "-"}
          label={"Data de início do novo pai"}
        />
      </Col>
    </Row>
  );
};

const AreaInfoCell = ({ icon, info, label }) => (
  <Col sm={24} md={24} lg={24} style={{ width: "100%", marginBottom: 12 }}>
    <Row>
      <Col>{icon}</Col>
      <Col style={{ marginLeft: 12 }}>
        <Row>
          <Col>{info}</Col>
        </Row>
        <Row>
          <Col style={{ color: "grey", fontSize: "12px" }}>{label}</Col>
        </Row>
      </Col>
    </Row>
  </Col>
);

export default ParentAreaModalInfo;
